import { observer } from 'mobx-react';
import { useCallback } from 'react';
import OrderSwitchers from '../../components/OrderSwitchers/OrderSwitchers';
import PaymentSwitchers from '../../components/PaymentSwitchers/PaymentSwitchers';
import PaymentMethods from '../../components/PaymnetMethods/PaymentMethods';
import branchEditStore from '../../store/branchEditStore';
import { IBranchPaymentTypeOption } from '../../types/branchEdit';
import Text, { TEXT } from 'src/view/components/Text/Text';

const OrderSettings = observer(() => {
  const onChangePaymentTypes = useCallback((paymentTypes: IBranchPaymentTypeOption[]) => {
    branchEditStore.changePaymentTypes(paymentTypes);
  }, []);

  return (
    <div className="d-flex flex-column mt-12">
      <Text type={TEXT.SECTION_HEADER} text="branch_orders_settings_block_header" className="mb-4" />

      <div className="d-flex">
        <div className="d-flex flex-column mr-12">
          <OrderSwitchers />

          <div className="d-flex gap-60">
            <PaymentMethods
              paymentTypes={branchEditStore.paymentTypes}
              isValid={branchEditStore.validation.details.paymentTypes}
              titled
              onChange={onChangePaymentTypes}
            />
            <PaymentSwitchers />
          </div>
        </div>
      </div>
    </div>
  );
});

export default OrderSettings;
